import { createStore } from 'effector';
import { createEvent } from 'effector';

const initialValue: { mix_algo?: number, tons?: number, recipes_count?: number } = {
    mix_algo: 3,
    tons: 0,
    recipes_count: undefined,
};

const updateMixAlgo = createEvent<number>();
const updateTons = createEvent<number>();
const updateRecipesCount = createEvent<number>();

const mixingQueryParamsStore = createStore(initialValue)
    .on(updateMixAlgo, (state, newMixAlgo) => ({ ...state, mix_algo: newMixAlgo }))
    .on(updateTons, (state, newTons) => ({ ...state, tons: newTons }))
    .on(updateRecipesCount, (state, newRecipesCount) => ({ ...state, recipes_count: newRecipesCount }));


export { updateMixAlgo, updateTons, updateRecipesCount, mixingQueryParamsStore };